
import { Component, Vue, Watch } from 'vue-facing-decorator'
import OrderList from './com/order-list.vue'

@Component({
  components: {
    OrderList,
  }
})
export default class extends Vue {

  postData: any = null;
  loading = false;

  get userId() {
    return this.$route.query.id;
  }

  getGender(v) {
    switch (v) {
      case 1:
        return '男'
      case 2:
        return '女'
    }
    return '未知'
  }

  /** 跳到邀请人的详情，用当前路由 path，避免和菜单里配的 path 写死两份 */
  gotoInviter() {
    this.$goto({
      path: this.$route.path,
      query: { id: this.postData.inviterInfo.id },
    });
  }

  @Watch("$route.query.id")
  idWatcher() {
    this.getData();
  }

  async getData() {
    if (!this.userId) return;
    this.loading = true;
    let { error, data, message } = await this.$post("/manager/customer/view", {
      id: this.userId,
    });
    this.loading = false;
    if (error) return this.$error(message);
    this.postData = data;
  }

  created() {
    this.getData();
  }
}
